// By defaut Quill editor adds <p><br></p> to empty content.
// This function removes that and returns empty string. It is needed for sending correct data to backend.

export function sanitizeQuillContent(value) {
  const isEmpty = value === '<p><br></p>' || value === '<p></p>' || value.trim() === '';
  return isEmpty ? '' : value;
}
